




























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PaginationModel, VHeaders } from '@/models/pagedlistmodel';
import { Validator } from 'vee-validate';
import { Base } from './base';
 import {customerService} from '@/shared';

@Component({
    components: {
        Grid: () => import('./app.grid.vue'),
    },
    props: ['dialog', 'email1', 'email2'],

})

export default class EmailTrackingComponent extends Base {
    get trigger(): boolean {
        return this.$props.dialog;
    }
    set trigger(val) {
        this.$emit('closedialog', val);
    }
    public $validator: Validator;
    public loading: boolean = false;
    public pagination = new PaginationModel('createdAt', true, 5);
    public dialog: boolean;
    public email1: string;
    public email2: string;
    public storeId: number = 0;
    public tenantId: number = 0;
    public enterpriseId: number = 0;
    public headers: VHeaders[] = [
        {
            text: this.$parent.$t('emailTracking.headers.from') as string,
            align: 'left',
            sortable: true,
            value: 'fromEmail',
        },
        {
            text: this.$parent.$t('emailTracking.headers.to') as string,
            align: 'left',
            sortable: true,
            value: 'toEmail',
        },
        {
            text: this.$parent.$t('emailTracking.headers.subject') as string,
            align: 'left',
            sortable: true,
            value: 'subject',
        },
        {
            text: this.$parent.$t('emailTracking.headers.status') as string,
            align: 'left',
            sortable: true,
            value: 'status',
        },
        {
            text: this.$parent.$t('emailTracking.headers.openCount') as string,
            value: 'opensCount',
            align: 'left',
        },
        {
            text: this.$parent.$t('emailTracking.headers.lastEventTime') as string,
            value: 'lastEventTime',
            align: 'left',
            fieldType: 'date',
        },
    ];
    public items: any = [];

    public mounted() {
        this.$watch('dialog', (newVal, oldVal) => {
            if (newVal) {
                this.getTrackingRecords(newVal);
            }
        });
    }
    public async getTrackingRecords(recordKey): Promise<void> {
        try {
            this.loading = true;
            const response = await customerService.getEmailTrackingInfo(this.email1, this.email2);
            this.items = [];
            this.items = response.results;
            if (this.items) {
                this.pagination.totalItems = response.results.length || 0;
            }
        } finally {
            this.loading = false;
        }
    }

    public closeDialog() {
        this.trigger = false;
        this.$validator.reset();
    }

    public updatePaging(paging: any) {
        this.pagination = paging;
    }
}
